'use strict';

var cov_124207kr0u = function () {
  var path = '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/common/contacts/create-contact/create-contact.component.js',
      hash = '78cc2caa1bfe994bd5e6d9dbb8a44b98e8545336',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/ryanluton/Developer/divcon/divcon-tools/src/app/common/contacts/create-contact/create-contact.component.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 50,
          column: 5
        }
      },
      '1': {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 11,
          column: 3
        }
      },
      '2': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 42
        }
      },
      '3': {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 16,
          column: 21
        }
      },
      '4': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 22,
          column: 6
        }
      },
      '5': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 21,
          column: 9
        }
      },
      '6': {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      '7': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 32,
          column: 11
        }
      },
      '8': {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 30,
          column: 13
        }
      },
      '9': {
        start: {
          line: 31,
          column: 10
        },
        end: {
          line: 31,
          column: 28
        }
      },
      '10': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 40,
          column: 6
        }
      },
      '11': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 24
        }
      },
      '12': {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 39,
          column: 7
        }
      },
      '13': {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 56
        }
      },
      '14': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 44,
          column: 6
        }
      },
      '15': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 24
        }
      },
      '16': {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 49,
          column: 43
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 1
          },
          end: {
            line: 2,
            column: 2
          }
        },
        loc: {
          start: {
            line: 2,
            column: 13
          },
          end: {
            line: 50,
            column: 1
          }
        }
      },
      '1': {
        name: 'controller',
        decl: {
          start: {
            line: 15,
            column: 11
          },
          end: {
            line: 15,
            column: 21
          }
        },
        loc: {
          start: {
            line: 15,
            column: 38
          },
          end: {
            line: 45,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 19
          }
        },
        loc: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 22,
            column: 5
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 24,
            column: 19
          }
        },
        loc: {
          start: {
            line: 24,
            column: 24
          },
          end: {
            line: 33,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 27,
            column: 14
          },
          end: {
            line: 27,
            column: 15
          }
        },
        loc: {
          start: {
            line: 27,
            column: 21
          },
          end: {
            line: 32,
            column: 9
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 20
          }
        },
        loc: {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 40,
            column: 5
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 23
          }
        },
        loc: {
          start: {
            line: 42,
            column: 28
          },
          end: {
            line: 44,
            column: 5
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_124207kr0u.s[0];
(function () {
  ++cov_124207kr0u.f[0];

  var component = (++cov_124207kr0u.s[1], {
    bindings: {
      close: '&',
      dismiss: '&',
      resolve: '<'
    },
    templateUrl: 'app/common/contacts/create-contact/create-contact.html',
    controller: controller
  });

  ++cov_124207kr0u.s[2];
  controller.$inject = ['ContactService'];

  function controller(ContactService) {
    ++cov_124207kr0u.f[1];

    var self = (++cov_124207kr0u.s[3], this);

    ++cov_124207kr0u.s[4];
    self.cancel = function () {
      ++cov_124207kr0u.f[2];
      ++cov_124207kr0u.s[5];

      self.dismiss({
        $value: 'cancel'
      });
    };

    ++cov_124207kr0u.s[6];
    self.create = function () {
      ++cov_124207kr0u.f[3];
      ++cov_124207kr0u.s[7];

      ContactService.create(self.contact).then(function (uid) {
        ++cov_124207kr0u.f[4];
        ++cov_124207kr0u.s[8];

        self.close({
          $value: uid
        });
        ++cov_124207kr0u.s[9];
        self.contact = {};
      });
    };

    ++cov_124207kr0u.s[10];
    self.$onInit = function () {
      ++cov_124207kr0u.f[5];
      ++cov_124207kr0u.s[11];

      self.contact = {};
      ++cov_124207kr0u.s[12];
      if (self.resolve.customerId) {
        ++cov_124207kr0u.b[0][0];
        ++cov_124207kr0u.s[13];

        self.contact.customer = self.resolve.customerId;
      } else {
        ++cov_124207kr0u.b[0][1];
      }
    };

    ++cov_124207kr0u.s[14];
    self.$onDestroy = function () {
      ++cov_124207kr0u.f[6];
      ++cov_124207kr0u.s[15];

      self.contact = {};
    };
  }

  ++cov_124207kr0u.s[16];
  angular.module('dc-contacts').component('createContact', component);
})();